import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Sticky from "Components/Sticky/index";
import { PageWrapperT4 } from "Components/Common/Wrapper/PageWrapper";
import {  FlexWrapperT13 } from "Components/Common/Wrapper/FlexWrapper";
import HeaderSection from "./HeaderSection";
import StatusTab from "./StatusTab";
import { Spacer } from "Components/Common/Spacer/index";
import { isDesmet, isDesmetSupplier } from "Utils/index";
import InfoDetailsTable from "./InfoDetailsTable";
import FilterBox from "./FilterBox";
import RFQ from "Models/RFQ";
import {
  CREATE_FRESH_RFQ,
  CREATE_SUPPLIER_CONTRACT,
  CREATE_TRANSPORTATION_RFQ,
  GET_SUPPLIER_NAME_LIST,
  GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS,
  GET_TRANSPORTER_MAPPING_LIST,
} from "Constants/actionConstants";
import { SUPPLIER_RFQ } from "Constants/commonConstants";
import ActionBlurLoader from "Components/ActionLoader/LoaderWithBlur";
import ModalT1 from "Components/Common/Modal/ModalT1";
import ModalCardT3 from "Components/EXIMCargoTracking/ModalCardT3";
import MaterialDetailsTable from "./MaterialDetailsTable";
import VehicleDetailsTable from "./vehicleDetailsTable";
import moment from "moment";
import { getUser } from "Utils/storage";

export class SupplierOrTransportationRequestsDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusTabBtnList: [
        {
          id: 2,
          name: "New",
          isActive: true,
          count: 0,
          isVisible: true,
        },
        {
          id: 3,
          name: "Pending",
          isActive: false,
          count: 0,
          isVisible: true,
        },
        {
          id: 5,
          name: "Closed",
          isActive: false,
          count: 0,
          isVisible: true,
        },
        {
          id: 1,
          name: "Draft",
          isActive: false,
          count: 0,
          isVisible: isDesmetSupplier(),
        },
      ],
      type: 2,
      search:"",
      isModalPopupOpen: false,
      selectMaterialPackingList: [],
      selectSupplierName:null,
      selectedTransporterNameItem : null,
      startDate: null,
      endDate: null,
      dateRangeFocused:false
    };
  }

  componentDidMount() {
    this.handleGetSupplierTransportationContractsDetails();
    this.handleGetSupplierNameList();
    this.handleGetTransporterMappingList();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { statusDetails } = this.props;
    const {
       statusTabBtnList, 
       type,
       search,
       selectSupplierName,
       selectedTransporterNameItem,
       startDate,
       endDate
       } = this.state;

    if (statusDetails !== prevProps.statusDetails) {
      this.handleSetCountToStatusTabBtnList();
    }

    if (type !== prevState.type || 
      search !== prevState.search ||
      selectSupplierName !== prevState.selectSupplierName ||
      selectedTransporterNameItem !== prevState.selectedTransporterNameItem ||
      // startDate !== prevState.startDate || 
      endDate !== prevState.endDate 
      ) {
      this.handleGetSupplierTransportationContractsDetails();
    }
  }

  handleGetSupplierTransportationContractsDetails = () => {
    const { dispatch } = this.props;

    const {
      type,
      search,
      selectSupplierName,
      selectedTransporterNameItem,
      startDate,
      endDate
    } = this.state;

    const supplierName = !!selectSupplierName?selectSupplierName.value:null;
    const transporterId = !!selectedTransporterNameItem?selectedTransporterNameItem.value:null;
    const from = !!startDate?startDate.valueOf():null;
    const to = !!endDate?endDate.valueOf():null;

    const userType = isDesmetSupplier()

    const queryParams = {
      type,
      userType,
      search,
      supplierName,
      transporterId,
      from,
      to
    };

    dispatch({
      type: GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS,
      queryParams,
    });
  };

  handleGetSupplierNameList = () => {
    const { dispatch } = this.props;

    dispatch({
      type: GET_SUPPLIER_NAME_LIST,
    });

  };

  handleGetTransporterMappingList = () => {

    const { dispatch } = this.props;
    const user = getUser();
    const companyId = user.companyId
    const branchId = user.branchId
    const type = 2
    const isMultimode = false
    const isWarehouse = false

    const queryParams = {
      companyId,
      branchId,
      type,
      isMultimode,
      isWarehouse
    };

    dispatch({
      type: GET_TRANSPORTER_MAPPING_LIST,
      queryParams
    });

  };

  handleSetCountToStatusTabBtnList = () => {
    const { statusDetails } = this.props;

    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.statusTabBtnList = prevState.statusTabBtnList.map((ele) => {
        const newELe = {
          ...ele,
        };

        if (ele.id === 2) {
          newELe.count = statusDetails.active_count;
        } else if (ele.id === 3) {
          newELe.count = statusDetails.bidding_count;
        } else if (ele.id === 5) {
          newELe.count = statusDetails.loi_count;
        } else if (ele.id === 1) {
          newELe.count = statusDetails.draft_count;
        }
        return newELe;
      });
      return updateState;
    });
  };

  handleGetActiveStatusTabBtnId = ()=>{
    const { statusTabBtnList } = this.state;
    let activeId  = 2
    statusTabBtnList.forEach((ele)=>{
      if(ele.isActive){
        activeId = ele.id
      }
    })
    return activeId
  }

  handleOnClickStatusTabBtn = (tabBtnId) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.statusTabBtnList = prevState.statusTabBtnList.map((ele) => {
        const newELe = {
          ...ele,
        };
        if (ele.id === tabBtnId) {
          newELe.isActive = true;
        } else {
          newELe.isActive = false;
        }
        return newELe;
      });
      updateState.type = tabBtnId;
      return updateState;
    });
  };

  getHeaderSectionTitle = () => {
    const C1 = isDesmetSupplier();
    const C2 = isDesmet();
    // if (C1) {
    //   return "Supplier Dashboard";
    // }
    // if (C2 && !C1) {
    //   return "Transportation Requests";
    // }
    if(C1 || C2){
      return "Transportation Requests";
    }

    return "No Data";
  };

  // handleCreateRFQBtn = () => {
  //   const { dispatch } = this.props;
  //   //  const type = SUPPLIER_RFQ;
  //   const type = 1;
  //   const rfq = new RFQ();
  //   rfq.seRFQType(type);
  //   //  if (type === 4) {
  //   //    rfq.rfqDetails.setServiceType(3, "Courier");
  //   //  }
  //   //  if (type === 5) {
  //   //    rfq.rfqDetails.setMultiLevelMovementType(1);
  //   //    rfq.rfqDetails.setShippingType(2);
  //   //    rfq.rfqDetails.setServiceType(4, "Container");
  //   //  }
  //   //  // if(type === 6) {
  //   //  //    rfq.rfqDetails.setServiceType(4);
  //   //  // }
  //   //  if (type !== 1) {
  //   //    rfq.rfqDetails.setServiceModes([]);
  //   //  }
  //   //  if (type === 9) {
  //   //    rfq.rfqDetails.setAcceptPartialSolution(false);
  //   //  }
  //   //  if (
  //   //    [...DEEPAK_PHENOLICS, ...DEEPAK_PHENOLICS_SAP].includes(
  //   //      getUser().companyId
  //   //    ) &&
  //   //    !rfq.rfqDetails.fuel_type
  //   //  ) {
  //   //    rfq.rfqDetails.setFuelType({ value: 4, name: "DIESEL" });
  //   //  }
  //   dispatch({
  //     type: CREATE_FRESH_RFQ,
  //     rfq: rfq.getApiData(),
  //   });
  // };

  handleOnClickForCreateRequestBtn = () => {
    const { history,dispatch } = this.props;
    const payload ={
      rfq_type: 1,
      consignor_details: {
        city: "",
        state: "",
        country:"",
        source_address: "",
        consignor_name: "",
        pin_code: "",
        consignor_code: "",
      },
      project_details: {
        project_name: "",
        project_id: "",
        po_name: "",
        po_number: "",
      },
      service_type: 1,
      service_type_name: "FTL",
      service_mode: [
        {
          id: 1,
          name: "Road",
        },
      ],
      cargo_details: [
        {
          id: 1,
          name: "Solid",
        },
      ],
      material_packing_list: [],
      packing_type: "",
      packing_type_name: "",
      handling_instructions: [1],
      temp_min: 0,
      temp_max: 0,
      temp_unit: 0,
      vehicle_details: {
        vehicle_type_name: "",
        vehicle_type: 0,
      },
      tentative_pickup_date: moment(new Date()).valueOf(),
      contact_details: {
        contact_person_name: "",
        contact_no: "",
      },
      supplier_docs: [],
      supplier_instruction: "",
      is_draft: true,
    }

    const onSuccess = (data={}) => {
      const rfqId = data.data.rfq_id
      const rfqType = data.data.rfq_type
      history.push(`/contracting/generic/supplierRFQCreateOrUpdateRequest/${rfqId}/${rfqType}/create`);
    };

    dispatch({
      type: CREATE_SUPPLIER_CONTRACT,
      payload,
      onSuccess,
    });



    
  };

  handleModalPopupOpen = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: true,
      };
      return updatepreviousState;
    });
  };

  handleModalPopupClose = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: false,
      };
      return updatepreviousState;
    });
  };

  handleOnClickForViewMaterials = (materialPackingListEle) => {
    this.setState(
      (prevState) => {
        const updateState = { ...prevState };
        updateState.selectMaterialPackingList = materialPackingListEle;
        return updateState;
      },
      () => [this.handleModalPopupOpen()]
    );
  };

  handleOnChangeForSearch = (event)=>{
   const {name , value} = event.target
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.search = value
      return updateState;
    });

  }

  handleOnChangeForSupplierName = (data)=>{
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.selectSupplierName = data;
      return updateState;
    });
  }

  handleOnChangeForTransporterName = (data)=>{
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.selectedTransporterNameItem = data;
      return updateState;
    });
  }


  handleOnClickCreateRequest = (ele) => {
    const { dispatch, history } = this.props;

    const payload = {
      rfq_id: ele.rfq_id
    }

    const onSuccess = (data) => {
      const rfqId = data.rfq_id
      const rfqType = data.rfq_type
      history.push(`/rfq/create/${rfqId}/${rfqType}`)
    }

    dispatch({
      type: CREATE_TRANSPORTATION_RFQ,
      payload,
      onSuccess
    })
  }

  handleOnClickForEditRFQRequest = (ele)=>{
    const {history} = this.props;
    const rfqId = ele.rfq_id
    const rfqType = ele.rfq_type
    history.push(`/contracting/generic/supplierRFQCreateOrUpdateRequest/${rfqId}/${rfqType}/update`);
  }

  handleOnChangeForDateRangeFocused = (dateRangeFocused)=>{
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.dateRangeFocused = dateRangeFocused;
      return updateState;
    });
  }

  handleOnChangeForDateRange = ( startDate, endDate)=>{
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.startDate = startDate;
      updateState.endDate = endDate;
      return updateState;
    });
  }

  handleOnClickVehicleDetails = (data = []) => {
    this.setState(
      (prevState) => {
        const updateState = { ...prevState };
        updateState.loiAccepetedTransporter = data;
        return updateState;
      },
      () => [this.handleModalVehiclePopupOpen()]
    );
  }

  handleModalVehiclePopupOpen = () => {
      this.setState((previousState) => {
        let updatepreviousState = {
          ...previousState,
          isModalVehiclePopupOpen: true,
        };
        return updatepreviousState;
      });
  }

  handleModalVehiclePopupClose = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalVehiclePopupOpen: false,
      };
      return updatepreviousState;
    });
  };
 

  // handleGetProviderMaterialPackingDetails = (rfqId) => {
  //   const { dispatch } = this.props;
  //   const queryParams = {
  //     rfqId
  //   }
  //   const onSuccess = ()=>{
  //     this.handleModalPopupOpen()
  //   }

  //   dispatch({
  //     type: GET_PROVIDER_MATERIAL_PACKING_DETAILS,
  //     queryParams,
  //     onSuccess
  //   });

  // };
  

  render() {
    const { 
      loaderT1,
       contractsDetailsList,
       supplierNameList,
       transporterMappingList,

      } = this.props;

    const {
      statusTabBtnList,
      isModalPopupOpen,
      selectMaterialPackingList,
      search,
      selectSupplierName,
      selectedTransporterNameItem,
      dateRangeFocused,
      startDate,
      endDate,
      isModalVehiclePopupOpen,
      loiAccepetedTransporter
    } = this.state;

    return (
      <Fragment>
        {loaderT1 && <ActionBlurLoader fixed={true} />}
        <div className="navBarWrapper">
          <Sticky></Sticky>
        </div>

        <ModalT1
          isOpenState={isModalPopupOpen}
          handleOnClickForClose={this.handleModalPopupClose}
        >
          <ModalCardT3 title={"Material Details"}>
            <MaterialDetailsTable
              selectMaterialPackingList={selectMaterialPackingList}
            />
          </ModalCardT3>
        </ModalT1>

        <PageWrapperT4>
          <HeaderSection
            title={this.getHeaderSectionTitle()}
            handleOnClickForCreateRequestBtn={
              this.handleOnClickForCreateRequestBtn
            }
          />
          <Spacer spacing={"10px"} />
          <FlexWrapperT13>
            <StatusTab
              statusTabBtnList={statusTabBtnList}
              handleOnClickStatusTabBtn={this.handleOnClickStatusTabBtn}
            />
            <FilterBox 
              search = {search}
              handleOnChangeForSearch = {this.handleOnChangeForSearch}
              supplierNameList = {supplierNameList}
              selectSupplierName = {selectSupplierName}
              handleOnChangeForSupplierName = {this.handleOnChangeForSupplierName}
              transporterMappingList = {transporterMappingList}
              selectedTransporterNameItem = {selectedTransporterNameItem}
              handleOnChangeForTransporterName = {this.handleOnChangeForTransporterName}
              activeStatusTabBtnId = {this.handleGetActiveStatusTabBtnId()}
              handleOnChangeForDateRangeFocused = {this.handleOnChangeForDateRangeFocused}
              dateRangeFocused = {dateRangeFocused}
              handleOnChangeForDateRange ={this.handleOnChangeForDateRange}
              startDate = {startDate}
              endDate = {endDate}
            />
          </FlexWrapperT13>
          <Spacer spacing={"10px"} />
          <InfoDetailsTable
            contractsDetailsList={contractsDetailsList}
            handleOnClickForViewMaterials={this.handleOnClickForViewMaterials}
            handleOnClickCreateRequest = {this.handleOnClickCreateRequest}
            handleOnClickForEditRFQRequest = {this.handleOnClickForEditRFQRequest}
            activeStatusTabBtnId = {this.handleGetActiveStatusTabBtnId()}
            handleOnClickVehicleDetails = {this.handleOnClickVehicleDetails}
          />
          {isModalVehiclePopupOpen &&
            <VehicleDetailsTable 
              onCancel={this.handleModalVehiclePopupClose}
              data={loiAccepetedTransporter}
            />
          }
        </PageWrapperT4>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  
  return {
    loaderT1: !!state.common.loaderT1,
    contractsDetailsList:
      state.supplierOrTransportationRequestsDashboard.contractsDetailsList,
    statusDetails:
      state.supplierOrTransportationRequestsDashboard.statusDetails,
    supplierNameList:
      state.supplierOrTransportationRequestsDashboard.supplierNameList,
    transporterMappingList:
      state.supplierOrTransportationRequestsDashboard.transporterMappingList,
  };
};

export default connect(mapStateToProps)(
  withRouter(SupplierOrTransportationRequestsDashboard)
);
